import { cdn } from "common/utils/cdn"
import { getTranslations } from "next-intl/server"

import Style from "./index.module.scss"

const EmptyYet = async () => {
	const t = await getTranslations("DetailPage.empty")
	return (
		<div className={Style.emptyYet}>
			<img src={`${cdn()}/images/index/empty.png`} alt="empty" />
			<span>{t("noDataYet")}</span>
		</div>
	)
}

export default EmptyYet
